import { Box } from '@mui/material';
import PeriodFilter from '@/components/Base/PeriodFilter';
import React, { useEffect, useState } from 'react';
import { groupBy } from 'lodash';
import FrequencyChart from '@/components/Base/FrequencyChart';
import { useConsolidationFrequency } from './api/getConsolidationFrequency';
import LoadingChart from '@/features/dashboard/components/LoadingChart';

const Frequency = ({ year: yearProp }: { year?: number }) => {
  const { data, isFetched, isFetching } = useConsolidationFrequency(yearProp);
  const listYears = Object
    .keys(groupBy(data, 'ano'))
    .map((item) => Number(item))
    .sort((a, b) => b - a);

  const [year, setYear] = useState<number | null>(null);

  useEffect(() => {
    if (isFetched && listYears.length) {
      setYear(listYears[0]);
    }
  }, [isFetched, listYears]);

  const onApplyFilter = (selectedYear) => {
    setYear(selectedYear);
  };

  const selected = data?.length ? data?.find((item) => Number(item.ano) === year) : null;
  return (
    <>
      <LoadingChart loading={isFetching} />

      {
        data?.length && selected && (
          <FrequencyChart title={'Histórico de Frequência dos alunos'} lineColor={'rgb(237, 226, 237)'}
                          pointColor={'rgb(183, 167, 203)'} data={data} />
        )
      }

      {
        isFetched && (
          <Box marginTop={'10px'}>
            <PeriodFilter year={year} years={listYears} onApplyFilter={onApplyFilter} />
          </Box>
        )
      }
    </>
  );
};

export default Frequency;
